<template>
  <div>
    <a-form-model-item :colon="false" label-align="left" label="Available Placeholders">
      <div class="word-list" data-testid="document-form-text-placeholders-list">
        <a-button v-for="word in placeholders" :key="word" @click="insertWordAtCursor(word)">
          {{ word }}
        </a-button>
      </div>
    </a-form-model-item>

    <a-form-model-item :colon="false" label-align="left" label="Body">
      <a-textarea
        ref="textarea"
        allow-clear
        v-model="body"
        :auto-size="{ minRows: 6, maxRows: 10 }"
        @input="saveCursorPosition"
        @click="saveCursorPosition"
        @keydown="saveCursorPosition"
        data-testid="document-form-text-body-input"
      />
    </a-form-model-item>
  </div>
</template>

<script>
import { Button, FormModel, Input } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapState: documentState } = createNamespacedHelpers('document')

export default {
  components: {
    'a-textarea': Input.TextArea,
    'a-form-model-item': FormModel.Item,
    'a-button': Button
  },
  props: {
    text: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      body: undefined,

      cursorPosition: 0
    }
  },
  watch: {
    text: {
      handler(newVal) {
        if (Array.isArray(newVal)) {
          this.body = newVal.map(item => item.value).join('')
        }
      },
      immediate: true
    }
  },
  computed: {
    ...documentState({
      placeholders: state => state.placeholders
    })
  },
  methods: {
    saveCursorPosition(event) {
      const textarea = this.$refs.textarea?.$el.querySelector('textarea')
      if (textarea) {
        this.cursorPosition = textarea.selectionStart
      }
    },

    insertWordAtCursor(word) {
      const before = this.body.slice(0, this.cursorPosition)
      const after = this.body.slice(this.cursorPosition)

      const space = before.trim() ? ' ' : ''
      this.body = `${before}${space}${word}${after}`

      this.cursorPosition += space.length + word.length

      this.$nextTick(() => {
        const textarea = this.$refs.textarea?.$el.querySelector('textarea')
        if (textarea) {
          textarea.setSelectionRange(this.cursorPosition, this.cursorPosition)
          textarea.focus()
        }
      })
    },

    splitTextByPlaceholders() {
      const parts = this.body.match(/(#\w+)|[^#]+/g)

      const result = []

      if (!parts) {
        this.$emit('save', result)
        return
      }

      parts.forEach(part => {
        if (part.startsWith('#')) {
          if (this.placeholders.includes(part)) {
            result.push({ value: part, placeholder: part })
          } else {
            result.push({ value: part })
          }
        } else {
          const normalizedText = part.replace(/\s+/g, ' ')
          result.push({ value: normalizedText })
        }
      })

      this.$emit('save', result)
    }
  }
}
</script>

<style scoped>
.word-list {
  display: flex;
  flex-direction: column;
  height: 200px;
  overflow: auto;
  gap: 8px;
}

.word-button {
  outline: none;
  border: 1px solid var(--border-color-base);
  border-radius: 10px;
  cursor: pointer;
}
</style>
